// @flow

import type { PricingPlan } from '@toggl/auth'

export const pricingPlanUrls = new Map<PricingPlan, string>([
  [0, '/track/signup/'],
  [100, '/track/signup/starter/monthly/'],
  [101, '/track/signup/starter/yearly/'],
  [102, '/track/signup/premium/monthly/'],
  [103, '/track/signup/premium/yearly/'],
])
